// Client-side balance preview; the server is the authority that rejects unbalanced entries.
const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;

export const lineTotals = (lines) => {
  const debit = round2(lines.reduce((sum, l) => sum + (Number(l.debit) || 0), 0));
  const credit = round2(lines.reduce((sum, l) => sum + (Number(l.credit) || 0), 0));
  return { debit: debit.toFixed(2), credit: credit.toFixed(2), balanced: debit === credit && debit > 0 };
};
